import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { CellPropTypes } from '../../../../../../prop-types/react-table';
import { ShipstationField } from '../../shipstation-field/shipstation-field';
import { messages } from './messages';

export const ShipstationFieldCell = ({ row }) => {
  return <ShipstationField templateAttribute={row.original} />;
};

ShipstationFieldCell.propTypes = CellPropTypes;

export const createShipstationFieldColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'shipstationField',
  Header: <FormattedMessage {...messages.shipstationField} />,
  Cell: ShipstationFieldCell,
  width: 1,
});
